import { Helmet } from "react-helmet";

const HeadSection = ({ data }: { data?: any }) => {
  const seoTitle = data?.seoTitle;
  const seoDescription = data?.description;
  const canonicalUrl = data?.canonicalUrl || `${window.location.origin}${window.location.pathname}`;
  const featuredImage = data?.image?.fields?.file?.url;  // Assuming Contentful gives image object with 'url'
  const noIndex = data?.noindex;
  const noFollow = data?.nofollow;
  const keywords = data?.keywords;

  const robotsContent = `${noIndex ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}`;
  return (
    <Helmet>
      {seoTitle && <title>{seoTitle}</title>}
      {seoTitle && <meta property="og:title" content={seoTitle} />}
      
      {seoDescription && <meta name="description" content={seoDescription} />}
      {seoDescription && <meta property="og:description" content={seoDescription} />}
      
      {keywords && <meta name="keywords" content={Array.isArray(keywords) ? keywords.join(", ") : keywords} />}

      <link rel="canonical" href={canonicalUrl} />

      {featuredImage && <meta property="og:image" content={featuredImage} />}
      
      <meta name="robots" content={robotsContent} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default HeadSection;
